import {
  alpha,
  TextareaAutosize,
  TextareaAutosizeProps as MuiTextareaProps,
  styled,
} from "@mui/material";
import Label from "components/Label";

export type CustomTextareaProps = {
  label?: string;
  maxRows?: number;
} & MuiTextareaProps;

const StyledTextArea = styled(TextareaAutosize)<CustomTextareaProps>(
  ({ theme, maxRows }) => ({
    boxSizing: "border-box",
    width: "100%",
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.5,
    padding: "12px 14px",
    borderRadius: 14,
    color: theme.palette.text.primary,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.background.default, 0.28)
        : theme.palette.background.paper,
    border: `2px solid ${theme.palette.divider}`,
    minHeight: maxRows && maxRows > 1 ? maxRows * 28 : 48,
    resize: "vertical",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "::placeholder": {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
    "&:focus-visible": {
      outline: "none",
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 3px ${alpha(
        theme.palette.primary.main,
        theme.palette.mode === "dark" ? 0.22 : 0.16
      )}`,
    },
  })
);

const LightTextArea = ({ label, maxRows, ...props }: CustomTextareaProps) => {
  return (
    <>
      {label ? <Label label={label} /> : null}
      <StyledTextArea {...props} maxRows={maxRows} />
    </>
  );
};

export default LightTextArea;
